import { memo } from 'react';

const DividerV2 = memo(({ mode = 'horizontal', style, label, className = '' }) => {
  if (label) {
    return (
      <div className={`comp-divider-v2 with-label ${className}`} style={{ ...style }}>
        <div />
        <p>{label}</p>
        <div />
      </div>
    );
  }

  return <div className={`comp-divider-v2 ${mode} ${className}`} style={{ ...style }} />;
});

DividerV2.displayName = 'DividerV2';
export default DividerV2;
